var $4e3bc8cf783ad569$exports = {};
$4e3bc8cf783ad569$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Hodnota mus\xED by\u0165 ".concat(args.maxValue, " alebo skor\u0161ia.");
  },
  "rangeReversed": "D\xE1tum za\u010Diatku mus\xED by\u0165 skor\u0161\xED ako d\xE1tum konca.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Hodnota mus\xED by\u0165 ".concat(args.minValue, " alebo neskor\u0161ia.");
  },
  "unavailableDate": "Vybrat\xFD d\xE1tum je nedostupn\xFD."
};
export { $4e3bc8cf783ad569$exports as default };